import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhotoAlbumIcon(props: IconProps) {
    return <Icon {...props} iconKey={"photo_album"}/>
}
